import React, { useState } from 'react';
import { Header } from './components/Header';
import { JobsCTA } from './components/JobsCTA';
import { SocialFeed } from './components/SocialFeed';
import { Footer } from './components/Footer';
import { Navigation } from './components/Navigation';
import { OrderForm, ServiceType } from './components/OrderForm';
export function App() {
  const [activeOrderForm, setActiveOrderForm] = useState<ServiceType | null>(null);
  return <div className="min-h-screen w-full bg-[#FFF8F0] text-[#1A1A1A] font-sans selection:bg-[#C5A55A] selection:text-white flex flex-col" data-id="element-0">
      <Navigation onOrderClick={setActiveOrderForm} data-id="element-1" />

      <main className="flex-grow flex flex-col items-center w-full" data-id="element-2">
        <Header data-id="element-3" />

        <div className="w-full max-w-5xl mx-auto space-y-12 md:space-y-24 pb-20" data-id="element-4">
          <JobsCTA data-id="element-5" />
          <div className="w-full h-px bg-[#C5A55A]/20 max-w-xs mx-auto" data-id="element-6" />
          <SocialFeed data-id="element-7" />
        </div>
      </main>

      <Footer data-id="element-8" />

      {activeOrderForm && <OrderForm type={activeOrderForm} onClose={() => setActiveOrderForm(null)} data-id="element-9" />}
    </div>;
}